<template>
    <div>
        <CompaniesAdd/>
        <CompaniesList class="mt-4"/>
    </div>
</template>
<script>
    import CompaniesList from './CompaniesList';
    import CompaniesAdd from './CompaniesAdd';

    export default {
        name: 'companies',
        components: {CompaniesList, CompaniesAdd},
    }
</script>